<template>
  <div v-if="clients" id="invoice-form">
    <div class="options">
      <button @click="addArticle()"><i class="far fa-plus-circle"></i><span>Add Article</span></button>
      <button @click="saveInvoice(invoice)" :disabled="saved"><i class="far fa-save"></i><span>Save</span></button>
      <button @click="exportInvoice(invoice)"><i class="far fa-download"></i><span>Download</span></button>
      <div class="spacer"></div>
      <button @click="deleteInvoice(invoice)" class="delete"><i class="far fa-trash"></i><span>Delete</span></button>
    </div>

    <div class="input-group">
      <label>Template</label>
      <v-select placeholder="Choose a template" :options="templates" v-model="invoice.template" label="name" :searchable="false"></v-select>
    </div>


    <div class="input-group-collection">
      <div class="input-group">
        <label>Client</label>
        <v-autocomplete
          :items="filteredClients"
          v-model="client"
          :get-label="client => client ? client.company : ''"
          :component-item="clientItemTemplate"
          :auto-select-one-item="false"
          @change="updateClientItems">
        </v-autocomplete>
      </div>

      <div class="input-group">
        <label>Status</label>
        <v-select :options="status" v-model="invoice.status" :searchable="false" :clearable="false"></v-select>
      </div>
    </div>

    <input-group name="invoice-number" displayName="Number" placeholder="Number" v-model="invoice.number"></input-group>

    <v-date-picker
      mode="single"
      popover-visibility="focus"
      v-model='invoice.date'
      :formats="{input: 'D MMMM YYYY'}">
      <div class="input-group" slot-scope="props">
        <label>Date</label>
        <div class="input-icon-group">
          <i class="far fa-calendar"></i>
          <input
            type="text"
            placeholder="invoice Date"
            :value='props.inputValue'
            @change='props.updateValue($event.target.value)'>
        </div>
      </div>
    </v-date-picker>

    <input-group name="invoice-title" displayName="Title" placeholder="Title" v-model="invoice.title"></input-group>
    <div class="input-group-collection">
      <input-group name="invoice-payment-period" displayName="PP" placeholder="Payment Period" v-model="invoice.payment_period"></input-group>
      <input-group name="invoice-vat_percentage" displayName="VAT" placeholder="VAT Percentage" v-model="invoice.vat_percentage"></input-group>
      <input-group name="invoice-discount" displayName="Discount" placeholder="Discount" v-model="invoice.discount"></input-group>
    </div>

    <div class="input-group">
      <label>PC</label>
      <v-select placeholder="Payment Condition" :options="paymentConditions" v-model="invoice.paymentCondition" :searchable="false"></v-select>
    </div>

    <div class="articles">
      <div class="article" v-for="(article, index) in invoice.articles" :key="index">
        <div class="meta-group">
          <div class="article-meta">#{{ index + 1 }}</div>
          <button @click="deleteArticle(invoice, index)" class="delete"><i class="far fa-trash"></i></button>
        </div>
        <div>

          <v-date-picker
            mode="single"
            popover-visibility="focus"
            v-model='article.date'
            :formats="{input: 'D MMMM YYYY'}">
            <div class="input-group" slot-scope="props">
              <label>Date</label>
              <div class="input-icon-group">
                <i class="far fa-calendar"></i>
                <input
                  type="text"
                  placeholder="Article Date"
                  :value='props.inputValue'
                  @change='props.updateValue($event.target.value)'>
              </div>
            </div>
          </v-date-picker>

          <div class="descriptions">
            <input-group name="article.description" displayName="Description" placeholder="Description" v-model="article.description"></input-group>
            <input-group name="article.sub_description" displayName="Sub Description" placeholder="Sub Description" v-model="article.sub_description"></input-group>
            <input-group name="article.third_description" displayName="Third Description" placeholder="Third Description" v-model="article.third_description"></input-group>
          </div>
          <div class="input-group-collection">
            <input-group name="article.unit" displayName="Unit" placeholder="Unit" v-model="article.unit"></input-group>
            <input-group name="article.price_unit" displayName="Price/Unit" placeholder="Price/Unit" v-model="article.price_unit"></input-group>
            <input-group name="article.quantity" displayName="Quantity" placeholder="Quantity" v-model="article.quantity"></input-group>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import InputGroup from "@/components/inputs/InputGroup.vue";
import ClientAutocompleteItem from "@/components/client/ClientAutocompleteItem.vue";
export default {
  name: "Invoice",
  components: {
    InputGroup,
  },
  props: ["rawInvoice"],
  data() {
    return {
      moment: moment,

      selectedClient: null,
      clientItemTemplate: ClientAutocompleteItem,
      status: this.$store.getters.status,
      templates: this.$store.getters.orgTemplates,
      paymentConditions: this.$store.getters.paymentConditions,
      filteredClients: this.$store.getters.clients,
      filteredPaymentConditions: this.$store.getters.paymentConditions
    };
  },
  computed: {
    cacheInvoices() {
      return JSON.parse(this.$store.getters.cacheInvoices);
    },
    invoice() {
      let invoice = this.rawInvoice
      return invoice
    },
    client: {
      get() {
        if (this.selectedClient) {
          return this.selectedClient
        } else {
          return this.$store.getters.clientById(this.invoice.client_id)
        }
      },
      set(client) {
        if (client){
          this.selectedClient = client
          this.invoice.client_id = client.id
        }
      }
    },
    company() {
      return this.$store.getters.company || {};
    },
    clients() {
      return this.$store.getters.clients;
    },
    saved() {
      let self = this
      self.cacheInvoices.push(self.invoice)
      let cache = self.cacheInvoices[self.invoice.index]
      if (!cache) {
        console.log('NO CACHE', self.cacheInvoices, self.invoice)
      }
      cache.date = new Date(self.cacheInvoices[self.invoice.index].date);

      let saved = _.isEqual(self.cacheInvoices[self.invoice.index], self.invoice);
      (!saved) ? self.invoice.unsaved = true : delete(self.invoice.unsaved)

      console.log(self.invoice, 'diff', self.$helpers.deepDiffObj(cache, self.invoice)) // changed values

      return saved
    }
  },
  watch: {
    invoice() {
      console.log('watched')
      this.selectedClient = this.$store.getters.clientById(this.invoice.client_id)
    }
  },
  methods: {
    calculateArticleTotal(article) {
      let articleTotal = article.price_unit * article.quantity;
      return +(Math.round(articleTotal + "e+2") + "e-2");
    },
    addArticle() {
      !this.invoice.articles ? this.invoice.articles = [] : ''
      this.invoice.articles.push({
        date: null,
        created_at: moment().format('YYYY-MM-DD HH:mm:ss'),
        price_unit: 0,
        quantity: 0,
        unit: null
      })
    },
    updateClientItems (company) {
      this.filteredClients = this.clients.filter(client => {
        return (new RegExp(company.toLowerCase())).test(client.company.toLowerCase())
      })
    },
    deleteArticle(invoice, index) {
      invoice.articles.splice(invoice.articles[index], 1)
    },
    saveInvoice(invoice) {
      if(!this.saved) {
        delete(invoice.unsaved)
        console.log(invoice)
        this.$store.dispatch("syncCachedInvoicesById", invoice)
        this.$store.dispatch("updateInvoice", invoice);
      }
    },
    deleteInvoice(invoice) {
      this.$store.dispatch("deleteInvoice", invoice);
    },
    exportInvoice(invoice) {
      //TODO : make this an setting option
      document.title = `invoice${invoice.number}`;
      window.print()
      //TODO : make this one as global var
      document.title = "Bonos Invoicing";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/colors";

.input-select {
  padding: 10px;
  display: block;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background: none;
  option {
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    font-size: 18px;
    background: red;
  }
}

#invoice-form {
  flex-grow: 1;
  padding: 20px 20px 20px 10px;
  border: 1px solid $color-border;
  border-radius: 4px;
  margin: 0 10px 0 0;
  .non-input {
    border: none;
  }
  .spacer {
    flex-grow: 1;
  }
}

.input-icon-group {
  display: flex;
  align-items: center;
  border: 1px solid $color-border;
  flex-grow: 1;
  border-radius: 4px;
  width: 50px;
  position: relative;
  input {
    padding: 10px 0 10px 32px;
    border: none;
    width: 100%;
    background: none;
  }
  i {
    position: absolute;
    margin: 0 5px 0 10px;
    color: #666;
  }
}

.articles {
  .article {
    margin-top: 24px;
    padding: 10px;
    border: 1px solid rgba(var(--color-theme-values), 0.4);
    border-radius: 4px;
    display: flex;
    align-items: flex-start;
    .meta-group {
      text-align: center;
      padding: 5px;
      background: rgba(var(--color-theme-values), 0.1);
      border-radius: 4px;
      button {
        background: none;
        border: none;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        font-size: 16px;
        cursor: pointer;
        margin-top: 10px;
        &:hover {
          background: rgba(var(--color-theme-values), 0.2);
        }
      }
      .delete {
        color: $color-danger;
        &:hover {
          background: rgba($color-danger, 0.1);
        }
      }
    }
  }
}

.input-group-collection {
  display: flex;
}

.input-group {
  flex-grow: 1;
  margin-top: 10px;
  display: flex;
  align-items: center;
  label {
    font-size: 14px;
    text-align: right;
    margin: 0 10px;
  }
}

@media print {
  #invoice-form {
    display: none;
  }
}
</style>

